<div class="dialog-container">
  <div mat-dialog-title class="mat-dialog-title">
    <span class="mat-dialog-title-style">Información del referido</span>
  </div>

  <mat-dialog-content>
    <!-- Resumen del referido -->
    <div class="referido-summary">
      <div class="summary-item">
        <span class="label">Nombre del referido</span>
        <span class="value">{{ referidoResumen.nombre }}</span>
      </div>

      <div class="summary-item">
        <span class="label">Correo electrónico</span>
        <span class="value">{{ referidoResumen.correo }}</span>
      </div>

      <div class="summary-item">
        <span class="label">Número celular</span>
        <span class="value">{{ referidoResumen.celular }}</span>
      </div>

      <div class="summary-item">
        <span class="label">Fecha</span>
        <span class="value">{{ referidoResumen.fechaAfiliacion }}</span>
      </div>

      <div class="summary-item">
        <span class="label">Estado referido</span>
        <span class="value status">{{ referidoResumen.estado }}</span>
      </div>
    </div>

    <div class="mat-elevation-z2 mt-4 table-scroll-container">
      <div class="table-scroll">
        <table mat-table [dataSource]="dataSource" class="w-100 bordered-table">
          <!-- Nombre beneficiario -->
          <ng-container matColumnDef="nombreBeneficiario">
            <th mat-header-cell *matHeaderCellDef>Nombre beneficiario</th>
            <td mat-cell *matCellDef="let row">{{ row.nombreBeneficiario }}</td>
          </ng-container>

          <!-- Número de documento -->
          <ng-container matColumnDef="numDocBeneficiario">
            <th mat-header-cell *matHeaderCellDef>Número de documento</th>
            <td mat-cell *matCellDef="let row">{{ row.numDocBeneficiario }}</td>
          </ng-container>

          <!-- Programa -->
          <ng-container matColumnDef="programa">
            <th mat-header-cell *matHeaderCellDef>Programa</th>
            <td mat-cell *matCellDef="let row">{{ row.programa }}</td>
          </ng-container>

          <!-- Fecha afiliación -->
          <ng-container matColumnDef="fechaAfiliacion">
            <th mat-header-cell *matHeaderCellDef>Fecha de afiliación</th>
            <td mat-cell *matCellDef="let row">{{ row.fechaAfiliacion }}</td>
          </ng-container>

          <!--Estado gestión de pago -->
          <ng-container matColumnDef="estadoGestionPago">
            <th mat-header-cell *matHeaderCellDef>Estado gestión de pago</th>
            <td mat-cell *matCellDef="let row">{{ row.estadoGestionPago }}</td>
          </ng-container>

          <!--Fecha de pago referente-->
          <ng-container matColumnDef="fechaPagoReferente">
            <th mat-header-cell *matHeaderCellDef>Fecha de pago referente</th>
            <td mat-cell *matCellDef="let row">{{ row.fechaPagoReferente }}</td>
          </ng-container>

          <!-- Valor a pagar -->
          <ng-container matColumnDef="valoraPagar">
            <th mat-header-cell *matHeaderCellDef>Valor a pagar</th>
            <td mat-cell *matCellDef="let row">{{ row.valoraPagar }}</td>
          </ng-container>

          <!-- Observaciones -->
          <ng-container matColumnDef="observaciones">
            <th mat-header-cell *matHeaderCellDef>Observaciones</th>
            <td mat-cell *matCellDef="let row">{{ row.observaciones }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator
        [pageSize]="5"
        [pageSizeOptions]="[5]"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="dialog-actions">
    <button
      mat-raised-button
      color="primary"
      class="btn-accept"
      type="button"
      (click)="dialogRef.close()"
    >
      Aceptar
    </button>
  </mat-dialog-actions>
</div>
